<template>
  <div>
    <v-layout
      @click="goTo"
      class="card-noti pa-3"
      :class="item.Read__c ? '' : 'not-read'"
    >
      <v-flex shrink class="mr-3" style="position: relative">
        <!-- <span v-if="!item.Read__c" class="new"> New </span> -->
        <span v-if="item.NeedAcknowledge__c && !Acknowledged__c" class="new">
          <span class="material-symbols-outlined small-icon"> priority_high </span>
        </span>

        <!-- ถ้าเป็น Icon -->
        <NotiCardItemIcon :type="item.NotificationType__c" />

        <!-- ถ้าเป็นรูปภาพที่มาจาก API -->
        <!-- <v-img
          min-width="40"
          max-width="40"
          min-height="40"
          max-height="40"
          style="border-radius: 100%"
          :src="item.image"
        ></v-img> -->
      </v-flex>
      <v-flex>
        <div class="txt-title">{{ item.Header__c }}</div>
        <div class="desc">{{ decodeHtml(item.Body__c) }}</div>
        <div class="date">
          <i class="far fa-clock"></i>
          <span class="ml-2">
            <!-- {{ format(new Date(item.LastModifiedDate), "dd/MM/yyyy HH:mm") }} -->
            {{ item.NotificationDateTime__c ? new Date(item.NotificationDateTime__c).toLocaleDateString("th-TH", {
                    day: "numeric",
                    month: "short",
                    year: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                  }) : checkDate(item) }}
            <!-- {{
              item.LastModifiedDate
                ? new Date(item.LastModifiedDate).toLocaleDateString("th-TH", {
                    day: "numeric",
                    month: "short",
                    year: "2-digit",
                  })
                : ""
            }} -->
            <!-- {{
              item.LastModifiedDate
                ? new Date(item.LastModifiedDate).toLocaleTimeString("th-TH", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : ""
            }} -->
          </span>
        </div>
      </v-flex>
    </v-layout>

    <!-- Dialog -->
    <v-dialog v-model="dialog" width="500">
      <v-card class="pa-6">
        <div
          class="font-18 font-w-700 mb-4 d-flex justify-space-between align-center"
        >
          <div>แจ้งเตือน</div>
          <div>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider class="my-3"></v-divider>

        <v-layout align-center>
          <v-flex shrink class="mr-3">
            <NotiCardItemIcon :width="30" :height="30" :type="item.type" />
            <!-- <v-img
              min-width="40"
              max-width="40"
              min-height="40"
              max-height="40"
              style="border-radius: 100%"
              :src="item.image"
            ></v-img> -->
          </v-flex>
          <v-flex>
            <div class="font-18 font-w-700">{{ item.Header__c }}</div>
          </v-flex>
        </v-layout>

        <div class="date mt-2">
          <i class="far fa-clock"></i>
          <span class="ml-2">
            <!-- {{ format(new Date(item.LastModifiedDate), "dd/MM/yyyy HH:mm") }} -->
            {{
              item.LastModifiedDate
                ? new Date(item.LastModifiedDate).toLocaleDateString("th-TH", {
                    day: "numeric",
                    month: "short",
                    year: "2-digit",
                  })
                : ""
            }}
            {{
              item.LastModifiedDate
                ? new Date(item.LastModifiedDate).toLocaleTimeString("th-TH", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : ""
            }}
          </span>
        </div>

        <div class="font-14 mt-4">{{ item.Body__c }}</div>

        <div class="mt-12">
          <v-btn
            color="#4CA22F"
            dark
            block
            depressed
            style="border-radius: 10px"
            @click="onAccept()"
          >
            รับทราบ
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NotiCardItemIcon from "./NotiCardItemIcon.vue";
import { controllerName, mainSite, logOutUrl } from "../store/constants";
import { format } from "date-fns";
export default {
  components: {
    NotiCardItemIcon,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      format,
      dialog: false,
    };
  },
  methods: {
    checkDate(item) {
      let today = format(new Date(), "dd/MM/yyyy");
      let startDate = format(new Date(item.LastModifiedDate), "dd/MM/yyyy");

      console.log("startDate: ", startDate);
      console.log("today: ", today);

      // if startDate <= today : return create date to show
      if (startDate <= today) {
        console.log("using create date");
        return (
          new Date(item.CreatedDate).toLocaleDateString("th-TH", {
            day: "numeric",
            month: "short",
            year: "2-digit",
          }) +
          " " +
          new Date(item.CreatedDate).toLocaleTimeString("th-TH", {
            hour: "2-digit",
            minute: "2-digit",
          })
        );
      }
      // else : return publish date to show
      else if (startDate > today) {
        console.log("using publish date");
        // todo : change CreatedDate to publish date
        return (
          new Date(item.CreatedDate).toLocaleDateString("th-TH", {
            day: "numeric",
            month: "short",
            year: "2-digit",
          }) +
          " " +
          new Date(item.CreatedDate).toLocaleTimeString("th-TH", {
            hour: "2-digit",
            minute: "2-digit",
          })
        );
      } else {
        return "";
      }
    },
    onAccept() {
      this.dialog = false;
      this.$emit("onAccept", this.item);
    },
    goTo() {
      this.onAccept();
      if (
        this.item.NotificationType__c == "News" ||
        this.item.NotificationType__c == "Promotion" ||
        this.item.NotificationType__c == "Franchise"
      ) {
        window.location.href =
          mainSite + "NewsDetail?Id=" + this.item.TargetingRecord__c;
      } else {
        let page;
        if (this.item.Case__r.Case_Type__c === "Inquiry") {
          if(this.item.Case__r.Sub_Case_Type__c === "การขอโปรโมชันรายสาขา"){
            page = "PromotionDetail";
          }else if(this.item.Case__r.Sub_Case_Type__c === "การติดตาม/ขอสื่อกิจกรรมส่งเสริมการขาย"){
            page = "AdvertiseDetail";
          }else{
            page = "InquiryDetail";
          }
        } else if (this.item.Case__r.Case_Type__c === "ComplimentAndFeedback") {
          page = "ComplimentAndFeedbackDetail";
        } else {
          page = "OthersDetail";
        }
        window.location.href = mainSite + page + "?Id=" + this.item.TargetingRecord__c;
      }
    },

    decodeHtml(url) {
      var txt = document.createElement("textarea");
      txt.innerHTML = url;
      return txt.value;
    },
  },
};
</script>

<style lang="scss">
.not-read {
  background-color: #edeff2;
  border-left: 3px solid #567adc;
}
.card-noti {
  .txt-title {
    font-weight: 600;
    font-size: 14px;
    color: #212b36;
  }
  .desc {
    font-size: 12px;
    font-weight: 500;
    color: #637381;
  }
  .date {
    font-size: 12px;
    font-weight: 500;
    color: #637381;
  }
  .new {
    background: #e02421;
    border-radius: 28px;
    font-size: 7px;
    color: #fff;
    position: absolute;
    top: -2px;
    right: -4px;
    z-index: 1;
    padding: 0px 3px;
  }
}
.card-noti:hover {
  background-color: #edeff2a0;
  cursor: pointer;
}
.small-icon {
  font-size: 14px;
  // font-weight: 700;
  margin-top: 2px;
}
</style>
